import IconButton from "@material-ui/core/IconButton";
import React, { useRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useComponentSize from "@rehooks/component-size";
import NavigateAfterIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
  ACTIONS,
  partRefIdIsFirstPartRef,
  partRefIdIsLastPartRef,
} from "../../../../../Providers/TemplateInstanceProvider";
import DrawTemplate from "../../../../../components/Template/DrawTemplate";

const useStyles = makeStyles({
  templateContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  previousNextContainer: {
    display: "flex",
    alignItems: "center",
    zIndex: 10,
  },
  templateOuterContainer: {
    flexGrow: 1,
  },
  stretch: {
    flexGrow: 1,
    position: "relative",
    display: "flex",
  },
});

export default ({ year }) => {
  const classes = useStyles();
  const [state, dispatch] = useTemplateInstance();

  const previousPage = () => {
    dispatch({
      type: ACTIONS.PREVIOUS_PARTREF,
    });
  };

  const nextPage = () => {
    dispatch({
      type: ACTIONS.NEXT_PARTREF,
    });
  };

  const isFirstPage = partRefIdIsFirstPartRef(
    state.currentPartRefId,
    state.template
  );
  const isLastPage = partRefIdIsLastPartRef(
    state.currentPartRefId,
    state.template
  );

  return (
    <div className={classes.stretch}>
      <div className={classes.previousNextContainer}>
        {!isFirstPage && (
          <IconButton onClick={previousPage}>
            <NavigateBeforeIcon />
          </IconButton>
        )}
      </div>
      <div className={classes.templateOuterContainer}>
        <TemplateContainer year={year} />
      </div>
      <div className={classes.previousNextContainer}>
        {!isLastPage && (
          <IconButton onClick={nextPage}>
            <NavigateAfterIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
};

const TemplateContainer = ({ templateInstance, pageNum, year }) => {
  const [state, dispatch] = useTemplateInstance();

  const onSelectResource = (resource) => {
    dispatch({
      type: ACTIONS.SET_CURRENT_RESOURCE,
      id: resource.fullId,
    });
  };

  const ref = useRef();
  // `current` points to the mounted img element.
  const size = useComponentSize(ref);

  const classes = useStyles();
  return (
    <div ref={ref} className={classes.templateContainer}>
      <DrawTemplate
        containerSize={size}
        templateInstance={state}
        pageNum={pageNum}
        year={year}
        handleUserResourceClick={onSelectResource}
      />
    </div>
  );
};
